import { useState, useEffect } from 'react';
import { apiService, getCurrentLocale } from '../services/api';

interface ClinicPhoto {
  id: number;
  documentId: string;
  name: string;
  alternativeText?: string;
  caption?: string;
  url: string;
  formats?: {
    large?: { url: string; width: number; height: number; };
    medium?: { url: string; width: number; height: number; };
    small?: { url: string; width: number; height: number; };
    thumbnail?: { url: string; width: number; height: number; };
  };
  width?: number;
  height?: number;
}

interface ClinicPhotosSectionData {
  id: number;
  documentId: string;
  title: string;
  images: ClinicPhoto[];
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export const useClinicPhotosSection = () => {
  const [data, setData] = useState<ClinicPhotosSectionData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const locale = typeof window !== 'undefined' ? getCurrentLocale() : 'nl';

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await apiService.getClinicPhotosSection();
        setData(response);
        setError(null);
      } catch (err: any) {
        console.error('Error fetching clinic photos section:', err);
        setError(err.message || 'Failed to fetch clinic photos');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [locale]);

  return { data, loading, error };
}; 